import React, { useContext ,useEffect,useState} from 'react';
import i18n from '../../languages/i18n';
import { useTranslation } from 'react-i18next';
import { arrowBack } from '../../assets/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { verifyOTP ,register, registeration } from '../../services/auth';
import { getUserData } from '../../services/apis/user';
import RegistrationSuccess from '../shared/RegistrationSuccess';
import { UserContext } from '../../context/UserContext';
import { languageAr, toastConfig } from '../../helpers/helper';
import { toast } from 'react-toastify';

const VerifyRegistration = ({body,closeOtpModal,handleSignUp}) => {
  document.body.dir = i18n.dir();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { phoneNumber } = location.state || {};
  const [isRegisterSuccess, setIsRegisterSuccess] = useState(false);
  const [timeLeft, setTimeLeft] = useState(60); 
  const { setUserData } = useContext(UserContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

const actionResend=()=>{
  setTimeLeft(60)
  handleSignUp()
}

  const onSubmit=async(data)=>{
    const requestBody = {
      phoneNumber:body.phoneNumber,
      password:body.password,
      otpCode: `${data.otp1}${data.otp2}${data.otp3}${data.otp4}${data.otp5}${data.otp6}`,
      roleId: body.roleId,
      imgUrl: '',
    };
    try{
      const registrationResponse = await registeration(requestBody);     
      localStorage.setItem('token', registrationResponse.id_token);
      localStorage.setItem('userRole', registrationResponse?.user_role?.roleId);
      if (registrationResponse && registrationResponse.id_token) {
     
        const userResponse = await getUserData();
        setUserData(userResponse)
        setIsRegisterSuccess(true,closeOtpModal());
        localStorage.setItem('userData', JSON.stringify(userResponse));
        if(registrationResponse?.user_role?.roleId == 1){
          setTimeout(() => {
          setIsRegisterSuccess(false);
          navigate('/admin', { state: { phoneNumber: body.phoneNumber } });
          window.location.href = '/admin';
        }, 2000);
        }else{
          setTimeout(() => {
            setIsRegisterSuccess(false);
            navigate('/', { state: { phoneNumber: body.phoneNumber } });
            window.location.href = '/';
          }, 2000);
        }
      } else {
        toast.error('Registration failed, please try again.', {
          position: 'top-right',
        });
      }
    }catch(error){
        console.log(error)
        if(error.response.data.message == "Phone number exists already, It cannot be duplicated."){
          toast.error(t("login.schema.numberAlreadyExist"),toastConfig);
        }else if(error.response.data.message == "Otp is either expired or incorrect."){
          toast.error(t("login.schema.expireOrIncorrectdOtp"),toastConfig);
        }
    }
  }


  

  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer); 
  }, [timeLeft]);

  return (
    <div className=" rounded-lg max600:order-2 w-full space-y">
      <form onSubmit={handleSubmit(onSubmit)}>
        <h2 className="text-2xl font-bold text-center mb-10 text-customPurple">
          {t('login.label.welcome')}
        </h2>
        <h2 className="text-md  text-center text-[#3E0292] sm:mt-10">
          {t('forgetPass.verifyOTP.otp')}{' '}
        </h2>
        <h2 className="text-[#303030] text-center sm:mt-5 ">
          {t('forgetPass.verifyOTP.phoneOtp')}
          <span className="text-[#3E0292] ml-2 mr-2">{body.phoneNumber}</span>
        </h2>

        <div className="mt-9">
          <div className={`flex ${languageAr == "ar" ? "flex-row-reverse" : "flex-row-reverse"} justify-center gap-2 mb-6`}>
            <input
              className="w-12 h-12 text-center border rounded-md shadow-sm focus:border-[#3E0292] focus:ring-[#3E0292]"
              type="text"
              maxlength="1"
              pattern="[0-9]"
              inputmode="numeric"
              autoComplete="one-time-code"
              required
              name="otp1"
              {...register('otp1', { required: true })}
            />
            <input
              className="w-12 h-12 text-center border rounded-md shadow-sm focus:border-teal-500 focus:ring-teal-500"
              type="text"
              maxlength="1"
              pattern="[0-9]"
              inputmode="numeric"
              autoComplete="one-time-code"
              required
              name="otp2"
              {...register('otp2', { required: true })}
            />
            <input
              className="w-12 h-12 text-center border rounded-md shadow-sm focus:border-teal-500 focus:ring-teal-500"
              type="text"
              maxlength="1"
              pattern="[0-9]"
              inputmode="numeric"
              autoComplete="one-time-code"
              required
              name="otp3"
              {...register('otp3', { required: true })}
            />
            <input
              className="w-12 h-12 text-center border rounded-md shadow-sm focus:border-teal-500 focus:ring-teal-500"
              type="text"
              maxlength="1"
              pattern="[0-9]"
              inputmode="numeric"
              autoComplete="one-time-code"
              required
              name="otp4"
              {...register('otp4', { required: true })}
            />
            <input
              className="w-12 h-12 text-center border rounded-md shadow-sm focus:border-teal-500 focus:ring-teal-500"
              type="text"
              maxlength="1"
              pattern="[0-9]"
              inputmode="numeric"
              autoComplete="one-time-code"
              required
              name="otp5"
              {...register('otp5', { required: true })}
            />
            <input
              className="w-12 h-12 text-center border rounded-md shadow-sm focus:border-teal-500 focus:ring-teal-500"
              type="text"
              maxlength="1"
              pattern="[0-9]"
              inputmode="numeric"
              autoComplete="one-time-code"
              required
              name="otp6"
              {...register('otp6', { required: true })}
            />
          </div>
        </div>
       <div className='flex flex-row items-center justify-center'>
        <div className='text-[#3E0292] font-semibold text-[16px]'>{t("login.schema.useCodeRegistration")}</div>
        <div className='mx-3 text-[#3E0292]'>:</div>
        <div className='text-[#3E0292] font-bold text-[16px]'>{body.otpCode}</div>

        </div>

      <div className="text-center">
      {timeLeft > 0 ? (
        <div className='flex flex-row items-center mt-5 justify-center'>
         <div className='text-black font-semibold text-[16px]'>{t("login.schema.codeWillExpire")}</div>
        <div className='mx-3 text-black'>:</div>
        <div className='text-black font-bold text-[16px]'>{timeLeft}</div>
        <div className='text-black font-bold text-[16px] mx-3'>{t("login.schema.seconds")}</div>
        </div>
      ) : (
        <div className='mt-5 flex flex-row items-center justify-center'>
        <div className="text-[#ff0000] font-semibold text-[16px]">{t("login.schema.codeExpired")}</div>
        <button onClick={actionResend} className="bg-transparent font-bold underline text-[#3E0292] px-4 py-2 rounded">
           {t("login.schema.resendCode")}
        </button>
        </div>
      )}
    </div>


        {Object.keys(errors).length > 0 && (
          <div className="text-red-500 text-center mt-2">
            {errors.otp1 && <p>OTP 1 is required.</p>}
            {errors.otp2 && <p>OTP 2 is required.</p>}
            {errors.otp3 && <p>OTP 3 is required.</p>}
            {errors.otp4 && <p>OTP 4 is required.</p>}
            {errors.otp5 && <p>OTP 5 is required.</p>}
            {errors.otp6 && <p>OTP 6 is required.</p>}
          </div>
        )}

        <div className="flex justify-center mt-5">
          <button
            type="submit"
            className="bg-[#00CEBC] border border-[#00CEBC] rounded-[14px] text-[15px] text-white px-10 py-4 w-[70%] shadow-lg text-center"
          >
            {t('login.schema.verify')}
          </button>
        </div>
      </form>{' '}
    <RegistrationSuccess isOpen={isRegisterSuccess} />

    </div>
  );
};

export default VerifyRegistration;
